import {
  getNetworkLogServerState,
  getNetworkLogState,
  subscribeToNetworkLog,
  type NetworkLogState,
} from "@/utils/network-log/network-log-store";
import { useSyncExternalStore } from "react";

export function useNetworkLogState(): NetworkLogState {
  return useSyncExternalStore(subscribeToNetworkLog, getNetworkLogState, getNetworkLogServerState);
}

const getNetworkLogEntryCount = (): number => getNetworkLogState().entries.length;
const getServerNetworkLogEntryCount = (): number => 0;

/**
 * Narrow entry-count subscription for always-mounted chrome (e.g. the navbar admin
 * menu): re-renders only when the count changes, not on every store write while
 * recording.
 */
export function useNetworkLogEntryCount(): number {
  return useSyncExternalStore(
    subscribeToNetworkLog,
    getNetworkLogEntryCount,
    getServerNetworkLogEntryCount,
  );
}
